import * as React from 'react';
import {ReactNode} from 'react';
import {Button} from '~/components/Button';
import {withAnnotate, withCommas} from '~/lib/numbers';
import style from './helpers.module.scss';

export const renderBoolean = (value: boolean) =>
    <i className={[
        style.checkbox,
        value ? style.checkboxChecked : style.checkboxUnchecked,
        `${value ? 'fas' : 'far'} fa-${value ? 'check-square' : 'square'}`
    ].join(' ')}/>;

export const renderToggle = (value: boolean, callback: (value: boolean) => void) =>
    <i
        className={[
            style.toggle,
            value ? style.toggleOn : style.toggleOff,
            `far fa-${value ? 'toggle-on' : 'toggle-off'}`
        ].join(' ')}
        onClick={() => callback(!value)}
    />;

export const renderDollars = (value: number) =>
    `${withCommas((value || 0).toFixed(2))}$`;

export const renderPercents = (value: number) => `${(value || 0).toFixed(2)}%`;

export function renderAbbreviate(inValue, inMaxPlaces, inForcePlaces, inForceLetter) {
    let number = Number(inValue);
    let forceLetter = inForceLetter || false;
    if (forceLetter !== false) {
        return withAnnotate(number, inMaxPlaces, inForcePlaces, forceLetter);
    }
    let abbr;
    if (number >= 1e12) {
        abbr = 'T';
    } else if (number >= 1e9) {
        abbr = 'B';
    } else if (number >= 1e6) {
        abbr = 'M';
    } else if (number >= 1e3) {
        abbr = 'K';
    } else {
        abbr = '';
    }
    return withAnnotate(number, inMaxPlaces, inForcePlaces, abbr);
}

interface ICopyProps {
    text: string;
    children?: ReactNode;
    title?: string;
}

export function Copy(props: ICopyProps) {
    return !document.queryCommandSupported('copy')
        ? <span title={props.title}>{props.children}</span>
        : <><Button
            small
            className={style.copyButton}
            leftIcon={<i className={`far fa-copy ${style.copyButtonIcon}`}/>}
            onClick={() => {
                let copyField = document.createElement('textarea');
                copyField.innerText = props.text;
                document.body.appendChild(copyField);
                copyField.select();
                document.execCommand('copy');
                copyField.remove();
            }}
        /><span title={props.title}>{props.children}</span></>;
}
